import { GeneralFilter } from '~/core/features/filtering/GeneralFilter';
import { UpdateFilterPayload_ControlsState } from '~/core/features/filtering/types/filters.type';
import { State } from '~/core/state/types/state';

const updateFilterControls = (state: State, payload: UpdateFilterPayload_ControlsState): State => {
    const filter = new GeneralFilter();

    return {
        ...state,
        controls: state.controls.map((querySetControls) => {
            if (querySetControls.querySet.identifier !== payload.querySetIdentifier) {
                return querySetControls;
            }
            return {
                ...querySetControls,
                filters: querySetControls.filters.map((filterControls) => {
                    if (filterControls.identifier !== payload.filterIdentifier) {
                        return filterControls;
                    }

                    const filterState = state.sets
                        .find(
                            (querySetState) =>
                                querySetState.querySet.identifier === querySetControls.querySet.identifier
                        )
                        ?.filters.find((filterState) => filterState.identifier === filterControls.identifier);

                    if (!filterState) {
                        throw new Error('Filter state not found in updateFilterControls');
                    }

                    return filter.updateControlsState(filterControls, filterState, payload);
                }),
            };
        }),
    };
};

export default updateFilterControls;
